import {
  type ReactElement,
  type ReactNode,
  Children,
  isValidElement,
} from 'react';
import { FormattedMessage, type MessageDescriptor } from 'react-intl';

/**
 * Returns whether children only consists of stringifiable children, that can receive standard text formatting.
 * @internal
 */
export function canReceiveDefaultTextFormat(children: ReactNode): children is
  | string
  | number
  | boolean
  | null
  | undefined
  // oxlint-disable-next-line typescript/no-explicit-any
  | ReactElement<MessageDescriptor & { values: Record<string, any> }> {
  const childrenArray = Children.toArray(children);

  return childrenArray.every(
    (child) =>
      typeof child === 'string' ||
      typeof child === 'number' ||
      typeof child === 'boolean' ||
      child === null ||
      child === undefined ||
      (isValidElement(child) && child.type && child.type === FormattedMessage),
  );
}
